import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'
import DefaultPage from '../../Pages/DefaultPage/DefaultPage'
import { BrazeProvider } from '../../Context/BrazeContext/BrazeProvider'
import { AuthProvider } from '../../Api/firebase/authContext'
import { SeasonProvider } from '../../Context/SeasonContext'
import { VideoProvider } from '../../Context/VideoContext'

export const AppContextLayout: React.FC = () => {
  return (
    <Suspense fallback={<DefaultPage />}>
      <AuthProvider>
        <BrazeProvider>
          <SeasonProvider>
            <VideoProvider>
              <Outlet />
            </VideoProvider>
          </SeasonProvider>
        </BrazeProvider>
      </AuthProvider>
    </Suspense>
  )
}
